module.exports = __webpack_public_path__ + "img/turksandcaicos.b2ebeb39.svg";